/* CY PDP clone: shared runtime (P0, SPEC-v2 §3.3). Plain ES2017, no dependencies, one IIFE, window.CYPDP.
   Sections only mark up with data attributes; this file brings them to life:
   count, stock, marquee, timer, offer, video, carousel, acc, flip, reveal, journey, sticky, shine, buy, checkout, nav.
   Init: DOMContentLoaded (document), shopify:section:load (event.target); shopify:block:select shows final
   values for count + stock. Every module marks processed nodes in data-cy-ready, so double init is a no-op.
   Reduced motion: every module shows its final state. */
(function () {
  'use strict';
  if (window.CYPDP) return;

  var doc = document;
  var root0 = doc.documentElement;
  var MQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var HAS_IO = 'IntersectionObserver' in window;
  var HAS_RAF = typeof window.requestAnimationFrame === 'function';
  var raf = HAS_RAF ? window.requestAnimationFrame.bind(window) : function (f) { return setTimeout(f, 16); };

  function reduced() { return !!(MQ && MQ.matches); }
  function canAnimate() { return HAS_IO && HAS_RAF && !reduced(); }

  /* all elements matching sel inside root, root included */
  function all(root, sel) {
    var out = [];
    if (!root) return out;
    if (root.nodeType === 1 && root.matches && root.matches(sel)) out.push(root);
    if (root.querySelectorAll) {
      var list = root.querySelectorAll(sel);
      for (var i = 0; i < list.length; i++) out.push(list[i]);
    }
    return out;
  }

  /* data-cy-ready holds the module names that processed the node */
  function claim(el, mod) {
    var v = el.getAttribute('data-cy-ready') || '';
    if ((' ' + v + ' ').indexOf(' ' + mod + ' ') > -1) return false;
    el.setAttribute('data-cy-ready', v ? v + ' ' + mod : mod);
    return true;
  }

  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function flag(el, name, d) {
    var v = el.getAttribute(name);
    if (v === null) return d;
    v = String(v).toLowerCase();
    return !(v === 'false' || v === '0' || v === 'no' || v === 'off');
  }
  function emit(name, detail) {
    var ev;
    try { ev = new CustomEvent(name, { detail: detail }); } catch (e) {
      ev = doc.createEvent('CustomEvent'); ev.initCustomEvent(name, false, false, detail);
    }
    doc.dispatchEvent(ev);
  }
  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }
  function setHidden(el, hide) {
    if (hide) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
  }
  /* IntersectionObserver that calls fn(el) once per element */
  function onceVisible(el, opts, fn) {
    if (!HAS_IO) { fn(el); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); fn(en.target); }
      });
    }, opts);
    io.observe(el);
  }

  var SVG = {
    play: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.14v13.72a.8.8 0 0 0 1.22.68l10.4-6.86a.8.8 0 0 0 0-1.36L9.22 4.46A.8.8 0 0 0 8 5.14Z"/></svg>',
    pause: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4.5" width="4" height="15" rx="1"/><rect x="14" y="4.5" width="4" height="15" rx="1"/></svg>',
    mute: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path fill="currentColor" d="M11 4.7a.7.7 0 0 0-1.2-.5L6.4 7.6A1.4 1.4 0 0 1 5.4 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.4a1.4 1.4 0 0 1 1 .4l3.4 3.4a.7.7 0 0 0 1.2-.5z"/><path d="M22 9l-6 6M16 9l6 6"/></svg>',
    unmute: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path fill="currentColor" d="M11 4.7a.7.7 0 0 0-1.2-.5L6.4 7.6A1.4 1.4 0 0 1 5.4 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.4a1.4 1.4 0 0 1 1 .4l3.4 3.4a.7.7 0 0 0 1.2-.5z"/><path d="M16 9a5 5 0 0 1 0 6"/><path d="M19.36 18.36a9 9 0 0 0 0-12.73"/></svg>'
  };

  /* ================= count ================= */
  var COUNT_RE = /^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/;
  function countData(el) {
    if (el._cyCount) return el._cyCount;
    var txt = el.getAttribute('data-cy-final');
    if (txt === null) { txt = (el.textContent || '').trim(); el.setAttribute('data-cy-final', txt); }
    var m = COUNT_RE.exec(txt);
    if (!m) return null;
    var raw = m[2];
    var c = {
      pre: m[1], suf: m[3], txt: txt,
      val: parseFloat(raw.replace(/,/g, '')),
      dec: (raw.split('.')[1] || '').length,
      comma: raw.indexOf(',') > -1
    };
    el._cyCount = c;
    return c;
  }
  function countFmt(c, v) {
    var s = v.toFixed(c.dec);
    if (c.comma) {
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = p.join('.');
    }
    return c.pre + s + c.suf;
  }
  function countFinal(el) {
    var c = countData(el);
    if (c) el.textContent = c.txt;
    el._cyCountDone = true;
  }
  function countZero(el) {
    var c = countData(el);
    if (c) el.textContent = countFmt(c, 0);
  }
  function countRun(el) {
    var c = countData(el);
    if (!c || el._cyCountDone) return;
    el._cyCountDone = true;
    if (!canAnimate()) { el.textContent = c.txt; return; }
    var dur = Math.max(0, num(el.getAttribute('data-cy-dur'), 1200));
    var delay = Math.max(0, num(el.getAttribute('data-cy-delay'), 0));
    setTimeout(function () {
      var t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = dur ? Math.min(1, (t - t0) / dur) : 1;
        var e = p * (2 - p);
        el.textContent = p >= 1 ? c.txt : countFmt(c, c.val * e);
        if (p < 1) raf(step);
      }
      raf(step);
    }, delay);
  }
  var IO_COUNT = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
  function modCount(root) {
    all(root, '[data-cy-count]').forEach(function (el) {
      if (el.closest('[data-cy-stock]')) return; /* driven by stock */
      if (!claim(el, 'count')) return;
      if (!countData(el)) return;
      if (!canAnimate()) { countFinal(el); return; }
      countZero(el);
      onceVisible(el, IO_COUNT, countRun);
    });
  }

  /* ================= stock ================= */
  function stockFinal(el) {
    el.style.setProperty('--cy-stock', num(el.getAttribute('data-pct'), 0) + '%');
    all(el, '[data-cy-count]').forEach(countFinal);
  }
  function modStock(root) {
    all(root, '[data-cy-stock]').forEach(function (el) {
      if (!claim(el, 'stock')) return;
      var counts = all(el, '[data-cy-count]').filter(function (c) { return c !== el; });
      if (!canAnimate()) { stockFinal(el); return; }
      el.classList.add('cy-noanim');
      el.style.setProperty('--cy-stock', '0%');
      counts.forEach(function (c) { if (countData(c)) countZero(c); });
      void el.offsetWidth; /* commit 0% before transitions return */
      el.classList.remove('cy-noanim');
      onceVisible(el, IO_COUNT, function () {
        el.style.setProperty('--cy-stock', num(el.getAttribute('data-pct'), 0) + '%');
        counts.forEach(countRun);
      });
    });
  }

  function finalize(root) {
    all(root, '[data-cy-stock]').forEach(stockFinal);
    all(root, '[data-cy-count]').forEach(countFinal);
  }

  /* ================= marquee ================= */
  var marquees = [];
  function mqLayout(m) {
    var halves = m.querySelectorAll('.cy-mq__half');
    if (halves.length < 2 || !m._cySet) return;
    var w = m.clientWidth;
    if (!w) return; /* hidden: lay out on the next resize/load */
    var sets = m._cySets || 1;
    while (halves[0].scrollWidth < w && sets < 8) {
      for (var h = 0; h < 2; h++) {
        for (var i = 0; i < m._cySet.length; i++) {
          var c = m._cySet[i].cloneNode(true);
          if (c.nodeType === 1) {
            c.setAttribute('aria-hidden', 'true');
            if (c.removeAttribute) c.removeAttribute('id');
            all(c, '[id]').forEach(function (n) { n.removeAttribute('id'); });
          }
          halves[h].appendChild(c);
        }
      }
      sets++;
    }
    m._cySets = sets;
    var speed = Math.max(1, num(m.getAttribute('data-speed'), 40));
    var hw = halves[0].scrollWidth;
    if (hw > 0) m.style.setProperty('--cy-mq-dur', (hw / speed).toFixed(3) + 's');
    m.classList.add('is-ready');
  }
  function modMarquee(root) {
    all(root, '[data-cy-marquee]').forEach(function (m) {
      if (!claim(m, 'marquee')) return;
      var halves = m.querySelectorAll('.cy-mq__half');
      if (halves.length < 2) return;
      m._cySet = Array.prototype.slice.call(halves[0].childNodes).map(function (n) { return n.cloneNode(true); });
      m._cySets = 1;
      if (flag(m, 'data-pause-hover', false)) m.classList.add('cy-mq--hp');
      marquees.push(m);
      if (reduced()) { m.classList.add('is-ready'); return; }
      mqLayout(m);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { mqLayout(m); });
      if (HAS_IO) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { m.classList.toggle('is-off', !en.isIntersecting); });
        }).observe(m);
      }
    });
  }
  window.addEventListener('resize', debounce(function () {
    marquees = marquees.filter(function (m) { return doc.contains(m); });
    if (!reduced()) marquees.forEach(mqLayout);
  }, 150));
  window.addEventListener('load', function () { if (!reduced()) marquees.forEach(mqLayout); });

  /* ================= timer ================= */
  var timers = [];
  var timerState = { active: false, ms: 0, text: '' };
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  /* 24 Oct: data-minutes > 0 (sale bar evergreen_minutes) sets the period in minutes, else hours (min 1 h) */
  function timerPeriod(t) { return t.minutes > 0 ? t.minutes * 60000 : Math.max(1, t.hours) * 3600000; }
  function evergreenTarget(key, period) {
    var now = Date.now();
    var k = 'cyTimer:' + key;
    var t = parseInt(lsGet(k), 10);
    if (!(t > 0) || t - now > period) t = now + period;
    else if (t <= now) t += (Math.floor((now - t) / period) + 1) * period;
    lsSet(k, String(t));
    return t;
  }
  function midnightTarget() {
    var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();
  }
  function timerFallback(t) {
    t.fallback = true;
    if (t.mode === 'midnight') t.target = midnightTarget();
    else if (t.mode === 'hide') t.target = null;
    else if (t.mode === 'load') t.target = Date.now() + timerPeriod(t); /* fresh every load, no storage */
    else t.target = evergreenTarget(t.key, timerPeriod(t));
  }
  function timerTitle(t) {
    var swap = t.fallback && t.endValid;
    t.titles.forEach(function (el) {
      if (el._cyTitle === undefined) el._cyTitle = el.textContent;
      var after = el.getAttribute('data-title-after');
      el.textContent = swap && after ? after : el._cyTitle;
    });
  }
  function timerTick(t) {
    if (!doc.contains(t.el)) { clearInterval(t.iv); timers = timers.filter(function (x) { return x !== t; }); return; }
    var ms = t.target === null ? 0 : t.target - Date.now();
    if (t.target !== null && ms <= 0) {
      timerFallback(t);
      ms = t.target === null ? 0 : t.target - Date.now();
    }
    if (t.target === null) {
      t.el.setAttribute('hidden', '');
      t.el.classList.add('is-hidden');
      t.active = false; t.ms = 0; t.text = '';
      clearInterval(t.iv);
    } else {
      ms = Math.max(0, ms);
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400);
      var useDays = t.showDays && d >= 1 && !!t.u.dwrap;
      var h = useDays ? Math.floor(s / 3600) % 24 : Math.floor(s / 3600);
      var mi = Math.floor(s / 60) % 60;
      var se = s % 60;
      if (t.u.dwrap) setHidden(t.u.dwrap, !useDays);
      if (t.u.d) t.u.d.textContent = pad(d);
      if (t.u.h) t.u.h.textContent = pad(h);
      if (t.u.m) t.u.m.textContent = pad(mi);
      if (t.u.s) t.u.s.textContent = pad(se);
      t.active = true; t.ms = ms;
      var dText = t.showDays && d >= 1;
      var hh = dText ? Math.floor(s / 3600) % 24 : Math.floor(s / 3600);
      t.text = (dText ? d + 'd ' : '') + (t.minutes > 0 && !dText && hh === 0 ? '' : pad(hh) + ':') + pad(mi) + ':' + pad(se);
    }
    timerTitle(t);
    if (!t.ready) { t.ready = true; t.el.classList.add('is-ready'); }
    if (timers[0] === t) publishTimer(t);
  }
  function publishTimer(t) {
    var changed = timerState.active !== t.active || timerState.text !== t.text;
    timerState.active = t.active; timerState.ms = t.ms; timerState.text = t.text;
    CYPDP.timerState = timerState;
    all(doc, '[data-cy-timer-text]').forEach(function (el) { if (el.textContent !== t.text) el.textContent = t.text; });
    applyMirrors();
    if (changed) emit('cy:timer', { active: timerState.active, ms: timerState.ms, text: timerState.text });
  }
  function modTimer(root) {
    all(root, '[data-cy-timer]').forEach(function (el) {
      if (!claim(el, 'timer')) return;
      var scope = el.closest('.shopify-section') || el.parentElement || el;
      var end = Date.parse(el.getAttribute('data-end') || '');
      var t = {
        el: el,
        key: el.getAttribute('data-key') || 'default',
        mode: (el.getAttribute('data-after') || 'evergreen').toLowerCase(),
        hours: num(el.getAttribute('data-hours'), 2),
        minutes: num(el.getAttribute('data-minutes'), 0),
        showDays: flag(el, 'data-show-days', true),
        endValid: isFinite(end) && (el.getAttribute('data-after') || '').toLowerCase() !== 'load',
        fallback: false,
        target: null,
        titles: all(scope, '[data-cy-timer-title]'),
        u: {
          d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'),
          m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]'),
          dwrap: el.querySelector('[data-u-wrap="d"]')
        }
      };
      /* mode "load" (16 Oct): end_at ignored, title never swaps (endValid false), now + hours on every load */
      if (t.endValid && end > Date.now()) t.target = end; else timerFallback(t);
      timers.push(t);
      timerTick(t);
      if (t.target !== null) t.iv = setInterval(function () { timerTick(t); }, 1000);
    });
  }

  /* ================= gallery override =================
     cy-pdp-main gallery_1..8 set on a template -> snippets/cy-pdp-main-gallery.liquid renders those images with slide
     ids "<section>-cyg<n>". Dawn's product-info calls setActiveMedia("<section>-<product media id>", true) on a variant
     change; that id is not in this gallery, and Dawn would then fall back to slide 1 and throw on the missing thumb.
     Ignore those calls so a Kaching / variant switch never touches the override gallery. */
  function modGallery(root) {
    all(root, 'media-gallery[data-cy-gallery-override]').forEach(function (el) {
      if (!claim(el, 'gallery')) return;
      el.setActiveMedia = function (id, prepend) {
        if (!el.querySelector('[data-media-id="' + id + '"]')) return;
        var Ctor = window.customElements && window.customElements.get('media-gallery');
        if (Ctor && Ctor.prototype.setActiveMedia) return Ctor.prototype.setActiveMedia.call(el, id, prepend);
      };
    });
  }

  /* timer + offer drive the [data-cy-when-timer] / [data-cy-when-notimer] mirrors */
  function applyMirrors() {
    var o = CYPDP.offerState;
    var show = !!timerState.active && !(o && o.pct === 0);
    all(doc, '[data-cy-when-timer]').forEach(function (el) { setHidden(el, !show); });
    all(doc, '[data-cy-when-notimer]').forEach(function (el) { setHidden(el, show); });
  }

  /* ================= offer ================= */
  var CY_SOFTGELS = 30; /* softgels per pouch (24 Oct) */
  var offer = { seed: null, attached: false, picked: false, last: '', pending: false, fmt: '${{amount}}' };
  function parseMoney(s) {
    var v = parseFloat(String(s == null ? '' : s).replace(/[^\d.]/g, ''));
    return isFinite(v) ? v : 0;
  }
  function seedNum(v) {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return Number.isInteger(v) ? v / 100 : v; /* Liquid money ints are cents */
    return parseMoney(v);
  }
  function formatMoney(amount, fmt) {
    fmt = String(fmt || offer.fmt || '${{amount}}').replace(/<[^>]*>/g, '');
    var cents = Math.round((amount || 0) * 100);
    function grp(n, dec, ts, ds) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return s.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return grp(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return grp(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return grp(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return grp(cents, 2, "'", '.');
        default: return grp(cents, 2, ',', '.');
      }
    });
  }
  function readSeed() {
    var s = doc.querySelector('script[data-cy-offer-seed]');
    if (!s) return null;
    var j;
    try { j = JSON.parse(s.textContent || '{}'); } catch (e) { return null; }
    if (j.currency || j.money_format || j.format) offer.fmt = j.currency || j.money_format || j.format;
    var tq = cyTierQty(parseInt(j.tier, 10));
    return { price: seedNum(j.price), compare: seedNum(j.compare), unit: seedNum(j.unit_compare), days: tq * 30, units: tq };
  }
  /* 24 Oct r2 (Yves): pouches per tier come from the theme's tier config (pricing-cards blocks: qty), not from
     Kaching's deal quantities (Kaching still sells Buy 2 = 3 units, Buy 3 = 5 until Yves edits the app). */
  function cyTierCfg(tier) {
    var el = doc.querySelector('script[data-cy-bb-cfg]'), j = null;
    if (el) { try { j = JSON.parse(el.textContent || '{}'); } catch (e) { j = null; } }
    return (j && j.tiers && j.tiers[tier - 1]) || null;
  }
  function cyTierQty(tier) { var t = cyTierCfg(tier); return (t && t.qty > 0) ? t.qty : 0; }
  function cyBarTier(bar) {
    var kb = bar.closest('.kaching-bundles') || doc;
    return all(kb, '.kaching-bundles__bar').indexOf(bar) + 1;
  }
  function cyBarQty(bar) {
    return cyTierQty(cyBarTier(bar)) || kcUnits()[bar.getAttribute('data-deal-bar-id')] || kcTitleUnits(bar);
  }
  function kachingRoot() { return doc.querySelector('.kaching-bundles'); }
  function readKaching(kb) {
    var bar = kb.querySelector('.kaching-bundles__bar--selected');
    if (!bar) return null;
    var p = bar.querySelector('.kaching-bundles__bar-price');
    var c = bar.querySelector('.kaching-bundles__bar-full-price');
    var price = p ? parseMoney(p.textContent) : 0;
    if (!(price > 0)) return null;
    var dm = /(\d+)\s*-?\s*days?\b/i.exec(bar.textContent || '');
    var days = dm ? parseInt(dm[1], 10) : 0;
    /* pouches in the selected bar: Kaching config, else the title ("Buy 2 Get 1" = 3), else the day supply / 30 */
    var units = cyBarQty(bar) || (days ? Math.round(days / CY_SOFTGELS) : 0);
    if (cyTierQty(cyBarTier(bar))) days = units * 30;
    return { price: price, compare: c ? parseMoney(c.textContent) : 0, days: days, units: units };
  }
  function readSubscribed(kb) {
    if (kb) {
      var box = kb.querySelector('.kaching-bundles__subscriptions input[type="checkbox"]:checked, .kaching-bundles__subscriptions input[type="radio"]:checked');
      if (box && !/one.?time|no.?sub/i.test(box.value || '')) return true;
    }
    var scope = (kb && (kb.closest('product-info') || kb.closest('.shopify-section'))) || doc;
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) forms = doc.querySelectorAll('form[action*="/cart/add"]');
    var sp = forms.length ? forms[0].querySelector('[name="selling_plan"]') : null;
    if (!sp && kb) sp = kb.querySelector('[name="selling_plan"]');
    return !!(sp && sp.value);
  }
  function offerCompute(source) {
    var kb = kachingRoot();
    var v = (kb && readKaching(kb)) || offer.seed || { price: 0, compare: 0 };
    var price = v.price || 0;
    var compare = v.compare > price + 0.004 ? v.compare : 0;
    var pct = compare ? Math.round((compare - price) / compare * 100) : 0;
    var days = v.days || 0;
    var units = v.units || (days ? Math.round(days / CY_SOFTGELS) : 0);
    return {
      price: price, compare: compare, pct: pct,
      perday: days ? price / days : 0,
      /* 24 Oct: displayed price of the selected tier (Kaching shows the plan price when Subscribe is ticked) / softgels */
      persoftgel: units ? price / (units * CY_SOFTGELS) : 0,
      subscribed: readSubscribed(kb),
      picked: offer.picked,
      source: source
    };
  }
  function offerApply(st) {
    CYPDP.offerState = st;
    all(doc, '[data-cy-offer="price"]').forEach(function (el) { if (st.price) el.textContent = formatMoney(st.price); });
    all(doc, '[data-cy-offer="compare"]').forEach(function (el) {
      var hide = !st.compare || Math.abs(st.compare - st.price) < 0.005;
      if (!hide) el.textContent = formatMoney(st.compare);
      setHidden(el, hide);
    });
    all(doc, '[data-cy-offer="pct"]').forEach(function (el) {
      if (st.pct) el.textContent = String(st.pct);
      setHidden(el, !st.pct);
    });
    all(doc, '[data-cy-offer="perday"]').forEach(function (el) {
      if (st.perday) el.textContent = formatMoney(Math.round(st.perday * 100) / 100);
      var w = el.closest('[data-cy-perday]');
      if (w) setHidden(w, !st.perday);
    });
    all(doc, '[data-cy-offer="persoftgel"]').forEach(function (el) {
      if (st.persoftgel) el.textContent = formatMoney(Math.round(st.persoftgel * 100) / 100);
      var w = el.closest('[data-cy-persoftgel]');
      if (w) setHidden(w, !st.persoftgel);
    });
    all(doc, '[data-cy-offer-hide-zero]').forEach(function (el) { setHidden(el, !st.pct); });
    all(doc, '[data-cy-offer-show]').forEach(function (el) {
      var k = el.getAttribute('data-cy-offer-show');
      if (k === 'picked') {
        el.classList.toggle('is-picked', !!st.picked);
        if (st.picked) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
      } else if (k === 'sub') setHidden(el, !st.subscribed);
      else if (k === 'onetime') setHidden(el, !!st.subscribed);
    });
    root0.classList.toggle('cy-offer-picked', !!st.picked);
    root0.classList.toggle('cy-offer-sub', !!st.subscribed);
    applyMirrors();
  }
  function offerUpdate(source, force) {
    var st = offerCompute(source);
    var key = [st.price, st.compare, st.pct, st.perday, st.persoftgel, st.subscribed, st.picked].join('|');
    if (!force && key === offer.last) return;
    offer.last = key;
    offerApply(st);
    emit('cy:offer', st);
  }
  function offerSchedule() {
    if (offer.pending) return;
    offer.pending = true;
    raf(function () { offer.pending = false; offerUpdate('kaching'); });
  }
  /* Kaching bars: crossed-out price = units x the variant compare-at, SAVE % from that (18 Oct, owner call).
     Kaching's own "use product compare-at price" flag is off in its admin (app-owned, no API), so discounted bars
     cross out units x the selling price instead. Units per bar come from Kaching's page config (quantity, or
     buyQuantity + getQuantity), else the title ("Buy 2 Get 1" = 3, "Buy One" = 1). Writes the existing text node
     so Kaching's own later updates land on the same node and re-trigger this. */
  var kc = { units: null };
  function kcUnits() {
    if (kc.units) return kc.units;
    var map = {};
    all(doc, 'script[type="application/json"]').forEach(function (el) {
      var t = el.textContent || '';
      if (t.indexOf('"dealBars"') < 0) return;
      try {
        var j = JSON.parse(t), stack = [j];
        while (stack.length) {
          var o = stack.pop();
          if (!o || typeof o !== 'object') continue;
          if (Array.isArray(o.dealBars)) o.dealBars.forEach(function (b) {
            if (!b || !b.id) return;
            var n = b.quantity || ((b.buyQuantity || 0) + (b.getQuantity || 0));
            if (n > 0) map[b.id] = n;
          });
          for (var k in o) if (o[k] && typeof o[k] === 'object') stack.push(o[k]);
        }
      } catch (e) {}
    });
    kc.units = map;
    return map;
  }
  function kcTitleUnits(bar) {
    var t = (bar.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
    var w = { one: 1, two: 2, three: 3, four: 4, five: 5 };
    function n(x) { return /^\d+$/.test(x) ? parseInt(x, 10) : (w[x.toLowerCase()] || 0); }
    var m = /buy\s+(\w+)(?:.*?get\s+(\w+))?/i.exec(t);
    return m ? n(m[1]) + (m[2] ? n(m[2]) : 0) : 0;
  }
  function kcSetText(el, txt) {
    if (!el) return;
    for (var c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3 && /\S/.test(c.data)) { if (c.data !== txt) c.data = txt; return; }
    }
    if (el.textContent !== txt) el.insertBefore(doc.createTextNode(txt), el.firstChild);
  }
  function kcFix(kb) {
    var unit = offer.seed && offer.seed.unit;
    if (!(unit > 0)) return;
    all(kb, '.kaching-bundles__bar').forEach(function (bar, i) {
      var n = cyBarQty(bar);
      var tc = cyTierCfg(i + 1);
      if (tc && tc.title) kcSetText(bar.querySelector('.kaching-bundles__bar-title'), tc.title);
      var stEl = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (stEl && tc && tc.qty > 0 && /\d+\s*-?\s*days?/i.test(stEl.textContent)) kcSetText(stEl, stEl.textContent.replace(/\d+(\s*-?\s*days?)/i, (tc.qty * 30) + '$1').trim());
      var pEl = bar.querySelector('.kaching-bundles__bar-price');
      var fEl = bar.querySelector('.kaching-bundles__bar-full-price');
      var price = pEl ? parseMoney(pEl.textContent) : 0;
      if (!(n > 0) || !(price > 0) || !fEl) return;
      var full = Math.round(unit * n * 100) / 100;
      if (full <= price) return;
      kcSetText(fEl, formatMoney(full));
      var lEl = bar.querySelector('.kaching-bundles__bar-label');
      if (lEl && /\d+\s*%/.test(lEl.textContent)) {
        kcSetText(lEl, lEl.textContent.replace(/\d+\s*%/, Math.round((full - price) / full * 100) + '%').trim());
      }
    });
  }
  function kcWatch(kb) {
    var host = kb.closest('.shopify-app-block') || kb.parentElement || kb;
    kcFix(kb);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { var k = kachingRoot(); if (k) kcFix(k); })
        .observe(host, { subtree: true, childList: true, characterData: true });
    }
  }
  function offerAttach(kb) {
    offer.attached = true;
    kcWatch(kb);
    var host = kb.closest('.shopify-app-block') || kb.parentElement || kb;
    if ('MutationObserver' in window) {
      new MutationObserver(offerSchedule).observe(host, {
        subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class']
      });
    }
    ['kaching:bundle:selected', 'kaching:price:updated', 'kaching:subscription:changed',
      'kaching:subscription:toggled', 'kaching:selling_plan:changed'].forEach(function (n) {
      doc.addEventListener(n, offerSchedule);
      window.addEventListener(n, offerSchedule);
    });
    offerUpdate('kaching', true);
    offerGuard();
  }
  /* 24 Oct: Kaching's updatePrice writes its own full price (paid units x compare-at) into the ATC <s> after load;
     re-apply the computed offer state whenever a bound price/compare drifts from it (no event, no loop). */
  function offerGuard() {
    if (offer.guarded || !('MutationObserver' in window)) return;
    offer.guarded = true;
    var pend = false, hosts = [];
    var mo = new MutationObserver(function () {
      if (pend) return;
      pend = true;
      raf(function () {
        pend = false;
        var st = CYPDP.offerState;
        if (!st) return;
        var bad = all(doc, '[data-cy-offer="price"], [data-cy-offer="compare"], [data-cy-offer="pct"]').some(function (el) {
          var k = el.getAttribute('data-cy-offer');
          /* 24 Oct r2: no price in the ATC any more; Kaching's native-price write then lands in the pct span ("$59.98%") */
          if (k === 'pct') return st.pct > 0 && el.textContent.trim() !== String(st.pct);
          var v = k === 'price' ? st.price : st.compare;
          return v > 0 && !el.hidden && el.textContent.trim() !== formatMoney(v);
        });
        if (bad) offerApply(st);
      });
    });
    all(doc, '[data-cy-offer="price"], [data-cy-offer="compare"], [data-cy-offer="pct"]').forEach(function (el) {
      var h = el.closest('product-form') || el.closest('form') || el.parentElement;
      if (h && hosts.indexOf(h) < 0) { hosts.push(h); mo.observe(h, { subtree: true, childList: true, characterData: true }); }
    });
  }
  function modOffer() {
    if (offer.started) { if (CYPDP.offerState) offerApply(CYPDP.offerState); return; }
    var seedEl = doc.querySelector('script[data-cy-offer-seed]');
    var anyBinding = doc.querySelector('[data-cy-offer], [data-cy-offer-show], [data-cy-offer-hide-zero]');
    if (!seedEl && !anyBinding && !kachingRoot()) return;
    offer.started = true;
    offer.seed = readSeed();
    if (offer.seed) {
      /* first paint state from the seed (default tier); no event until Kaching attaches or 5 s pass */
      var st = offerCompute('seed');
      offer.last = [st.price, st.compare, st.pct, st.perday, st.persoftgel, st.subscribed, st.picked].join('|');
      offerApply(st);
    }
    doc.addEventListener('pointerdown', function (e) {
      if (!offer.picked && e.target.closest && e.target.closest('.kaching-bundles')) { offer.picked = true; setTimeout(offerSchedule, 150); }
    }, true);
    doc.addEventListener('keydown', function (e) {
      if (offer.picked || !(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) return;
      if (e.target.closest && e.target.closest('.kaching-bundles')) { offer.picked = true; setTimeout(offerSchedule, 150); }
    }, true);
    doc.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'selling_plan' || (e.target.closest && e.target.closest('.kaching-bundles')))) offerSchedule();
    });
    var t0 = Date.now();
    (function poll() {
      var kb = kachingRoot();
      if (kb) { offerAttach(kb); return; }
      if (Date.now() - t0 >= 5000) {
        offer.picked = true;
        offerUpdate('seed', true);
        return;
      }
      setTimeout(poll, 100);
    })();
  }

  /* ================= video ================= */
  /* Tile markups (all: [data-cy-video], optional data-mode="ugc|carousel", default ugc):
     a) element with data-src (on the tile or a child) + poster <img> + [data-cy-play]: <video> built on first tap;
     b) element holding <template><video>...</video></template>: cloned on first tap (same as a);
     c) element holding a <video> in the markup, e.g. Shopify `video_tag` output (<source>s, poster attribute);
        with a separate poster <img> it behaves like a) (cy-vid--cover), without one the video is its own poster;
     d) the <video data-cy-video src|<source> poster> itself.
     Tap/Enter/Space toggles. Play = with sound (muted retry only if the browser refuses), every other cy video stops
     (back to its poster) and any other video playing with sound pauses. ugc: no loop; carousel: loop + mute button.
     Leaving the viewport, scrolling the row/track, or `ended` stops the tile and shows the poster again. */
  var vidCurrent = null;
  var vidBound = false;
  function vidMode(tile) { return (tile.getAttribute('data-mode') || 'ugc').toLowerCase(); }
  function vidHost(tile) { return tile.tagName === 'VIDEO' ? null : tile; }
  function vidMarkup(tile) {
    if (tile.tagName === 'VIDEO') return tile;
    var v = tile.querySelector('video');
    return v && !v.classList.contains('cy-vid__gen') ? v : null;
  }
  function vidOwnPoster(tile) {
    if (tile.tagName === 'VIDEO') return false;
    var imgs = tile.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) if (!imgs[i].closest('video')) return true;
    return false;
  }
  function vidDataSrc(tile) {
    var el = tile.hasAttribute('data-src') ? tile : tile.querySelector('[data-src]');
    return el ? el.getAttribute('data-src') : '';
  }
  function vidHasSource(v) { return !!(v.getAttribute('src') || v.querySelector('source[src]')); }
  function vidPrep(tile, v) {
    tile._cyVideo = v;
    v._cyTile = tile;
    if (!v.hasAttribute('data-cy-preload')) v.setAttribute('data-cy-preload', v.getAttribute('preload') || 'metadata');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.playsInline = true;
    v.controls = false;
    v.removeAttribute('controls');
    v.loop = vidMode(tile) === 'carousel';
    v.addEventListener('ended', function () { if (!v.loop) vidStop(tile); });
    if (vidMode(tile) === 'carousel' && vidHost(tile)) vidMuteBtn(tile, v);
    return v;
  }
  function vidEl(tile) {
    if (tile._cyVideo) return tile._cyVideo;
    var v = vidMarkup(tile);
    if (!v) {
      var tpl = tile.querySelector('template');
      if (tpl && tpl.content) {
        tile.appendChild(tpl.content.cloneNode(true));
        v = tile.querySelector('video');
        if (v) v.classList.add('cy-vid__gen');
      }
    }
    var src = vidDataSrc(tile);
    if (!v) {
      if (!src) return null;
      v = doc.createElement('video');
      v.className = 'cy-vid__gen';
      v.setAttribute('preload', 'none');
      if (tile.getAttribute('data-poster')) v.poster = tile.getAttribute('data-poster');
      v.src = src;
      tile.appendChild(v);
    } else if (!vidHasSource(v) && src) {
      v.src = src;
    }
    v.classList.add('cy-vid__el');
    return vidPrep(tile, v);
  }
  function vidMuteBtn(tile, v) {
    var b = doc.createElement('button');
    b.type = 'button';
    b.className = 'cy-vid__mute';
    function sync() {
      b.innerHTML = v.muted ? SVG.mute : SVG.unmute;
      b.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
      b.setAttribute('aria-pressed', v.muted ? 'true' : 'false');
    }
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; sync(); });
    v.addEventListener('volumechange', sync);
    sync();
    tile.appendChild(b);
  }
  function vidFlash(tile, playing) {
    if (vidMode(tile) !== 'carousel' || !vidHost(tile)) return;
    var ov = tile.querySelector('.cy-vid__ov');
    if (!ov) { ov = doc.createElement('span'); ov.className = 'cy-vid__ov'; ov.setAttribute('aria-hidden', 'true'); tile.appendChild(ov); }
    ov.innerHTML = playing ? SVG.play : SVG.pause;
    ov.classList.remove('is-flash');
    if (reduced()) return;
    void ov.offsetWidth;
    ov.classList.add('is-flash');
  }
  /* stop every other cy tile; pause any other video that plays with sound (muted background loops keep going) */
  function vidPauseOthers(tile) {
    if (vidCurrent && vidCurrent !== tile) vidStop(vidCurrent);
    var vs = doc.querySelectorAll('video');
    for (var i = 0; i < vs.length; i++) {
      var o = vs[i];
      if (o.paused || (tile && o === tile._cyVideo)) continue;
      if (o._cyTile) { if (o._cyTile !== tile) vidStop(o._cyTile); } else if (!o.muted) { try { o.pause(); } catch (e) { /* ignore */ } }
    }
  }
  function vidMark(tile) {
    vidCurrent = tile;
    tile.classList.add('is-active', 'is-playing');
    tile.classList.remove('is-paused');
  }
  function vidPlay(tile) {
    var v = vidEl(tile);
    if (!v) return;
    vidPauseOthers(tile);
    vidMark(tile);
    for (var a = tile.parentElement; a; a = a.parentElement) { if (a._cyVidScroll) a._cyStart = a.scrollLeft; }
    v.removeAttribute('autoplay');
    v.preload = 'auto';
    v.muted = false;
    v.removeAttribute('muted');
    if (v.networkState === 3 && vidHasSource(v)) { try { v.load(); } catch (e) { /* ignore */ } }
    var p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && p.catch) {
      p.catch(function (err) {
        var name = err && err.name;
        if (name === 'AbortError') return; /* paused or reset before it started */
        if (name === 'NotAllowedError') {
          v.muted = true;
          v.play().catch(function () { vidStop(tile); });
          return;
        }
        var alt = vidDataSrc(tile);
        if (alt && v.getAttribute('src') !== alt && !v._cyAlt) {
          v._cyAlt = true;
          v.src = alt;
          v.play().catch(function () { vidStop(tile); });
          return;
        }
        if (window.console) console.warn('[CYPDP] video could not play', v.currentSrc || alt, err);
        vidStop(tile);
      });
    }
    vidFlash(tile, true);
  }
  function vidPause(tile) {
    var v = tile._cyVideo;
    if (v) v.pause();
    tile.classList.remove('is-playing');
    tile.classList.add('is-paused');
    vidFlash(tile, false);
  }
  function vidStop(tile) {
    var v = tile._cyVideo;
    if (v) {
      try { v.pause(); } catch (e) { /* not loaded */ }
      if (v.poster && !v.classList.contains('cy-vid__gen') && !tile.classList.contains('cy-vid--cover') && v.currentTime > 0) {
        /* the video is its own poster: load() brings the poster frame back */
        v.preload = v.getAttribute('data-cy-preload') || 'metadata';
        try { v.load(); } catch (e) { /* ignore */ }
      } else {
        try { v.currentTime = 0; } catch (e) { /* not loaded */ }
      }
    }
    tile.classList.remove('is-active', 'is-playing', 'is-paused');
    if (vidCurrent === tile) vidCurrent = null;
  }
  function vidToggle(tile) {
    if (tile.classList.contains('is-playing') && tile._cyVideo && !tile._cyVideo.paused) vidPause(tile); else vidPlay(tile);
  }
  function vidScrollWatch(el) {
    if (!el || el._cyVidScroll) return;
    el._cyVidScroll = true;
    el.addEventListener('scroll', function () {
      var t = vidCurrent;
      if (!t || !el.contains(t)) return;
      if (Math.abs(el.scrollLeft - (el._cyStart || 0)) > 40) vidStop(t);
    }, { passive: true });
  }
  function vidBindDoc() {
    if (vidBound) return;
    vidBound = true;
    /* playback started some other way (native UI, another script): keep "one video with sound" true */
    doc.addEventListener('play', function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO') return;
      var t = v._cyTile;
      if (t) {
        if (vidCurrent !== t) { vidPauseOthers(t); vidMark(t); }
      } else if (!v.muted && vidCurrent) {
        vidStop(vidCurrent);
      }
    }, true);
  }
  function modVideo(root) {
    vidBindDoc();
    all(root, '[data-cy-video]').forEach(function (tile) {
      if (!claim(tile, 'video')) return;
      var mv = vidMarkup(tile);
      if (mv) {
        if (vidOwnPoster(tile)) tile.classList.add('cy-vid--cover'); else tile.classList.add('cy-vid--inline');
        mv.classList.add('cy-vid__el');
        vidPrep(tile, mv);
        if (!vidHasSource(mv) && vidDataSrc(tile)) mv.src = vidDataSrc(tile);
      }
      if (!/^(A|BUTTON)$/.test(tile.tagName)) {
        if (!tile.hasAttribute('role')) tile.setAttribute('role', 'button');
        if (!tile.hasAttribute('tabindex')) tile.setAttribute('tabindex', '0');
      }
      tile.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.cy-vid__mute')) return;
        e.preventDefault();
        vidToggle(tile);
      });
      tile.addEventListener('keydown', function (e) {
        if (e.target !== tile) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); vidToggle(tile); }
      });
      if (HAS_IO) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (!en.isIntersecting && tile.classList.contains('is-active')) vidStop(tile); });
        }, { threshold: 0.2 }).observe(tile);
      }
      vidScrollWatch(tile.closest('[data-cy-video-group]'));
      vidScrollWatch(tile.closest('[data-cy-track]'));
    });
    all(root, '[data-cy-video-group]').forEach(function (g) {
      if (!claim(g, 'video')) return;
      vidScrollWatch(g);
      all(g, '[data-cy-track]').forEach(vidScrollWatch);
    });
  }

  /* ================= carousel ================= */
  function carStep(track) {
    var kids = Array.prototype.filter.call(track.children, function (c) { return c.offsetParent !== null || c.getClientRects().length; });
    if (kids.length > 1) return Math.abs(kids[1].offsetLeft - kids[0].offsetLeft) || kids[0].offsetWidth;
    return kids.length ? kids[0].offsetWidth : track.clientWidth;
  }
  function carUpdate(c) {
    var track = c._cyTrack;
    if (!track || !doc.contains(track)) return;
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var x = Math.abs(track.scrollLeft);
    var step = Math.max(1, carStep(track));
    var isStatic = max <= 2;
    c.classList.toggle('cy-carousel--static', isStatic);
    all(c, '[data-dir]').forEach(function (b) {
      var dir = num(b.getAttribute('data-dir'), 1);
      var off = isStatic || (dir < 0 ? x <= 2 : x >= max - 2);
      b.disabled = off;
      b.classList.toggle('is-disabled', off);
      b.setAttribute('aria-disabled', off ? 'true' : 'false');
    });
    var dotsBox = c.querySelector('[data-cy-dots]');
    if (!dotsBox) return;
    var n = isStatic ? 1 : Math.ceil((max - 2) / step) + 1;
    if (dotsBox._cyN !== n) {
      dotsBox._cyN = n;
      dotsBox.innerHTML = '';
      dotsBox.classList.add('cy-dots');
      for (var i = 0; i < n; i++) {
        var d = doc.createElement('button');
        d.type = 'button';
        d.className = 'cy-dot';
        d.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + n);
        d.setAttribute('data-i', String(i));
        dotsBox.appendChild(d);
      }
      dotsBox.classList.toggle('is-single', n <= 1);
    }
    var active = x >= max - 2 ? n - 1 : Math.min(n - 1, Math.round(x / step));
    Array.prototype.forEach.call(dotsBox.children, function (d, i) {
      d.classList.toggle('is-active', i === active);
      if (i === active) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
  }
  function modCarousel(root) {
    all(root, '[data-cy-carousel]').forEach(function (c) {
      if (!claim(c, 'carousel')) return;
      var track = c.querySelector('[data-cy-track]');
      if (!track) return;
      c._cyTrack = track;
      var ticking = false;
      function sched() { if (ticking) return; ticking = true; raf(function () { ticking = false; carUpdate(c); }); }
      function go(left) { track.scrollTo({ left: left, behavior: reduced() ? 'auto' : 'smooth' }); }
      c.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-dir]');
        if (b && c.contains(b)) {
          e.preventDefault();
          go(track.scrollLeft + num(b.getAttribute('data-dir'), 1) * carStep(track));
          return;
        }
        var d = e.target.closest && e.target.closest('[data-cy-dots] [data-i]');
        if (d && c.contains(d)) {
          e.preventDefault();
          var i = num(d.getAttribute('data-i'), 0);
          var max = track.scrollWidth - track.clientWidth;
          go(Math.min(max, i * carStep(track)));
        }
      });
      track.addEventListener('scroll', sched, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(sched).observe(track);
      else window.addEventListener('resize', debounce(sched, 150));
      carUpdate(c);
    });
  }

  /* ================= acc ================= */
  function accSummary(d) { return d.querySelector(':scope > summary') || d.querySelector('summary'); }
  function accAnimate(d, from, to, done) {
    if (d._cyAnim) { d._cyAnim.cancel(); d._cyAnim = null; }
    if (reduced() || !d.animate) { done(); return; }
    d.style.overflow = 'hidden';
    var a = d.animate({ height: [from + 'px', to + 'px'] }, { duration: to > from ? 350 : 300, easing: 'cubic-bezier(.4,0,.2,1)' });
    d._cyAnim = a;
    a.onfinish = function () { d._cyAnim = null; d.style.overflow = ''; done(); };
    a.oncancel = function () { d.style.overflow = ''; };
  }
  function accOpen(d) {
    var grp = d.closest('[data-cy-acc-group]');
    if (grp && flag(grp, 'data-single', true) && grp.hasAttribute('data-single')) {
      all(grp, 'details[data-cy-acc]').forEach(function (o) { if (o !== d && o.open && o.closest('[data-cy-acc-group]') === grp) accClose(o); });
    }
    var from = d.offsetHeight;
    d.open = true;
    d.classList.add('is-open');
    var to = d.offsetHeight;
    accAnimate(d, from, to, function () {});
  }
  function accClose(d) {
    var s = accSummary(d);
    var from = d.offsetHeight;
    var to = s ? s.offsetHeight + (d.offsetHeight - d.clientHeight) : 0;
    d.classList.remove('is-open');
    accAnimate(d, from, to, function () { d.open = false; });
  }
  function modAcc(root) {
    all(root, 'details[data-cy-acc]').forEach(function (d) {
      if (!claim(d, 'acc')) return;
      d.classList.toggle('is-open', d.open);
      var s = accSummary(d);
      if (!s) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.classList.contains('is-open')) accClose(d); else accOpen(d);
      });
    });
  }

  /* ================= flip ================= */
  function flipSet(card, on) {
    card.classList.toggle('is-flipped', on);
    card.setAttribute('aria-pressed', on ? 'true' : 'false');
    var f = card.querySelector('[data-cy-face="front"]');
    var b = card.querySelector('[data-cy-face="back"]');
    if (f) f.setAttribute('aria-hidden', on ? 'true' : 'false');
    if (b) b.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  function flipToggle(card) {
    var on = !card.classList.contains('is-flipped');
    var grp = card.closest('[data-cy-flip-group]');
    if (on && grp) all(grp, '[data-cy-flip].is-flipped').forEach(function (o) { if (o !== card) flipSet(o, false); });
    flipSet(card, on);
  }
  function modFlip(root) {
    all(root, '[data-cy-flip]').forEach(function (card) {
      if (!claim(card, 'flip')) return;
      if (!/^(A|BUTTON)$/.test(card.tagName)) {
        if (!card.hasAttribute('role')) card.setAttribute('role', 'button');
        if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
      }
      flipSet(card, card.classList.contains('is-flipped'));
      card.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href], input, select, textarea, [data-cy-noflip]')) return;
        flipToggle(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.target !== card) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); flipToggle(card); }
      });
    });
  }

  /* ================= reveal ================= */
  function modReveal(root) {
    all(root, '[data-cy-reveal]').forEach(function (el) {
      if (!claim(el, 'reveal')) return;
      if (!canAnimate()) { el.classList.add('is-in'); return; }
      onceVisible(el, { threshold: 0.15 }, function () { el.classList.add('is-in'); });
    });
  }

  /* ================= journey ================= */
  var journeys = [];
  var jTicking = false;
  function journeyUpdate() {
    jTicking = false;
    journeys = journeys.filter(function (j) { return doc.contains(j); });
    var line = window.innerHeight * 0.7;
    journeys.forEach(function (j) {
      var r = j.getBoundingClientRect();
      var h = r.height;
      var fillH = reduced() ? h : Math.max(0, Math.min(line - r.top, h));
      var fill = j.querySelector('[data-fill]');
      if (fill) fill.style.height = fillH + 'px';
      j.style.setProperty('--cy-progress', h ? (fillH / h).toFixed(4) : '0');
      all(j, '[data-dot]').forEach(function (d) {
        var dr = d.getBoundingClientRect();
        d.classList.toggle('on', reduced() || dr.top + dr.height / 2 <= line);
      });
    });
  }
  function journeySched() { if (!jTicking) { jTicking = true; raf(journeyUpdate); } }
  function modJourney(root) {
    var added = false;
    all(root, '[data-cy-journey]').forEach(function (j) {
      if (!claim(j, 'journey')) return;
      journeys.push(j);
      added = true;
    });
    if (added) {
      if (!modJourney.bound) {
        modJourney.bound = true;
        window.addEventListener('scroll', journeySched, { passive: true });
        window.addEventListener('resize', journeySched);
      }
      journeyUpdate();
    }
  }

  /* ================= sticky ================= */
  /* Round 4. The bar is moved under <body> on init: nested in the section, position:fixed is re-anchored by any
     ancestor that gets a transform, filter or contain (Dawn reveal classes, app wrappers), which parks the bar at the
     bottom of the product section, off screen exactly when it should show. The trigger is re-found on every check
     (main ATC by id > the product form's submit > Kaching's deal block > the info column) and needs a layout box: a
     cached node that an app re-renders or hides reads as a 0x0 rect at the top, so "bottom < 0" would never become
     true. Shown once the trigger has scrolled above the viewport, hidden again when it is back; it steps aside while
     Kaching's own sticky bar is on the page (no double bars). Click = the real main ATC (Kaching's deal and the
     selling plan ride on it). */
  function boxed(el) {
    if (!el || !el.isConnected) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 || r.height > 0;
  }
  function stickyForm(bar) {
    var id = bar.getAttribute('data-form');
    return id ? doc.getElementById(id) : null;
  }
  /* the main ATC: by id, else the product form's submit (connected, layout not required: a hidden button still submits) */
  function stickyAtc(bar) {
    var t = doc.getElementById(bar.getAttribute('data-target') || '');
    if (t && t.isConnected) return t;
    var f = stickyForm(bar);
    return f ? f.querySelector('[type="submit"], [name="add"]') : null;
  }
  /* what the bar watches: the first candidate that has a layout box */
  function stickyAnchor(bar) {
    var f = stickyForm(bar);
    var c = [doc.getElementById(bar.getAttribute('data-target') || ''),
      f && f.querySelector('[type="submit"], [name="add"]'),
      kachingRoot(),
      doc.getElementById(bar.getAttribute('data-anchor') || '')];
    for (var i = 0; i < c.length; i++) if (boxed(c[i])) return c[i];
    return null;
  }
  /* price: the selected Kaching deal when readable; no Kaching = form quantity x variant or selling-plan price;
     Kaching present but not readable = leave the Liquid fallback (variant price, compare-at struck) */
  function stickyPrice(bar) {
    var pEl = bar.querySelector('[data-cy-sticky-price]');
    var cEl = bar.querySelector('[data-cy-sticky-compare]');
    if (!pEl) return;
    var price, compare;
    var kb = kachingRoot();
    if (kb) {
      var k = readKaching(kb);
      if (!k) return;
      price = k.price; compare = k.compare;
    } else {
      var f = stickyForm(bar);
      var q = f && (f.querySelector('[name="quantity"]') || doc.querySelector('[name="quantity"][form="' + f.id + '"]'));
      var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      var unit = num(bar.getAttribute('data-price'), 0);
      var sp = f && f.querySelector('[name="selling_plan"]');
      (bar.getAttribute('data-plans') || '').split(',').forEach(function (pair) {
        var kv = pair.split(':');
        if (sp && sp.value && kv[0] === sp.value) unit = num(kv[1], unit);
      });
      price = unit * qty / 100;
      compare = num(bar.getAttribute('data-compare'), 0) * qty / 100;
    }
    if (!(price > 0)) return;
    pEl.textContent = formatMoney(price);
    if (cEl) {
      var hide = !(compare > price + 0.004);
      if (!hide) cEl.textContent = formatMoney(compare);
      setHidden(cEl, hide);
    }
  }
  function modSticky(root) {
    all(root, '[data-cy-sticky]').forEach(function (bar) {
      if (!claim(bar, 'sticky')) return;
      /* one bar per section id under <body>: the theme editor re-renders sections, so a stale moved copy goes first */
      if (bar.id) {
        all(doc.body, '[data-cy-sticky]').forEach(function (o) {
          if (o !== bar && o.id === bar.id && o.parentNode) o.parentNode.removeChild(o);
        });
      }
      if (bar.parentNode !== doc.body) doc.body.appendChild(bar);
      var btn = bar.querySelector('[data-cy-sticky-btn]');
      var on = null;
      function show(v) {
        if (v === on) return;
        on = v;
        bar.classList.toggle('is-visible', v);
        bar.setAttribute('aria-hidden', v ? 'false' : 'true');
        if ('inert' in bar) bar.inert = !v;
        if (v) stickyPrice(bar);
      }
      show(false);
      root0.classList.add('cy-sticky-on');
      function measure() { if (bar.offsetHeight) root0.style.setProperty('--cy-sticky-h', bar.offsetHeight + 'px'); }
      bar.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-cy-sticky-btn]');
        if (!b || b.disabled) return;
        e.preventDefault();
        var t = stickyAtc(bar);
        if (t) {
          if (!t.disabled && t.getAttribute('aria-disabled') !== 'true') t.click();
          return;
        }
        var a = stickyAnchor(bar);
        if (a) { try { a.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' }); } catch (err) { a.scrollIntoView(); } }
      });
      var io = HAS_IO ? new IntersectionObserver(function () { sched(); }) : null;
      var watched = null;
      function check() {
        if (!bar.isConnected) return;
        var a = stickyAnchor(bar);
        if (io && a !== watched) {
          if (watched) io.unobserve(watched);
          if (a) io.observe(a);
          watched = a;
        }
        var t = stickyAtc(bar);
        if (btn) btn.disabled = !!(t && t.disabled);
        var kc = doc.querySelector('kaching-bundles-sticky-atc.kaching-bundles-sticky-atc--visible');
        show(!!a && !kc && a.getBoundingClientRect().bottom < 0);
      }
      var ticking = false;
      function sched() { if (ticking) return; ticking = true; raf(function () { ticking = false; check(); }); }
      window.addEventListener('scroll', sched, { passive: true });
      window.addEventListener('resize', function () { measure(); sched(); }, { passive: true });
      window.addEventListener('pageshow', sched);
      window.addEventListener('load', function () { measure(); sched(); });
      doc.addEventListener('cy:offer', function () { stickyPrice(bar); });
      var f = stickyForm(bar);
      if (f) f.addEventListener('change', function () { setTimeout(function () { stickyPrice(bar); }, 0); });
      doc.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'quantity') setTimeout(function () { stickyPrice(bar); }, 0);
      });
      measure();
      stickyPrice(bar);
      check();
    });
  }
  /* theme editor: a removed main section takes its body-level bar with it */
  doc.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    var b = id ? doc.getElementById('CySticky-' + id) : null;
    if (b && b.parentNode === doc.body) b.parentNode.removeChild(b);
  });

  /* ================= shine ================= */
  function modShine(root) {
    all(root, '[data-cy-shine]').forEach(function (el) {
      if (!claim(el, 'shine')) return;
      if (!canAnimate()) return;
      onceVisible(el, { threshold: 0.1 }, function () {
        setTimeout(function () { el.classList.add('is-shining'); }, 1200);
      });
    });
  }

  /* ================= buy (delegated, works for sections loaded later) ================= */
  doc.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cy-buy]');
    if (!a) return;
    var box = doc.querySelector('[data-cy-buybox]');
    if (!box) return; /* no buy box on this page: follow the href */
    e.preventDefault();
    try { box.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' }); } catch (err) { box.scrollIntoView(); }
  });

  /* ================= checkout (skip cart, 16 Oct) ================= */
  /* Owner call 16 Oct: an add to cart goes straight to checkout, no cart page, notification or drawer. Armed by a
     submit of a form inside product-form[data-cy-skip-cart] (main ATC; the sticky bar clicks that same button, so
     Kaching's deal and the selling plan ride on it). Kaching Bundles wraps window.fetch at parse time; this wrapper
     sits outside it, so the response it sees is the one after Kaching's handler ran. Success = Dawn's cartUpdate
     publish (source product-form) or an OK /cart/add response, whichever first; an error (Dawn cartError, a
     JSON "status", a failed request) disarms and Dawn shows its message. html.cy-to-checkout hides any cart UI
     meanwhile (cy-pdp.css). Off in the theme editor. The pricing cards post on their own and go to /checkout too. */
  var co = { armed: 0, url: '/checkout', gone: false, t: null };
  function coDesign() { return !!(window.Shopify && window.Shopify.designMode); }
  function coDisarm() {
    co.armed = 0; clearTimeout(co.t);
    root0.classList.remove('cy-to-checkout');
  }
  /* 19 Oct: Kaching has no gift set, so the free eBook ($0 digital variant; Sweet Without the Spike since 24 Oct) rides
     on skip-cart checkouts from Buy 2 Get 1 up (coGiftWant). /cart/update sets qty 1 (adds it once, never doubles) and is not a /cart/add, so neither Kaching nor
     the wrapper below reacts to it. Capped at 4 s: a slow or failed call never holds the shopper back. */
  var CY_GIFT = 67758161101169;
  /* Same pass: Kaching's plan name ("Save More With Automatic Refills!") says nothing about frequency and is app-owned,
     so each subscription line gets a visible property the checkout prints under the item, read from the plan config
     ("Renews: every 4 weeks"). Kaching's own properties are merged in, never dropped. */
  var CY_RENEW = 'Renews';
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function coRenewText(alloc) {
    var n = 0, unit = '';
    try {
      (alloc.selling_plan.options || []).forEach(function (o) {
        if (o.name !== 'config') return;
        var b = (JSON.parse(o.value) || {}).billing || {};
        n = +b.frequency || 0; unit = String(b.interval || '').toLowerCase();
      });
    } catch (err) { /* unreadable config: generic line below */ }
    if (!n || !unit) return 'on a repeat schedule';
    return 'every ' + (n === 1 ? unit : n + ' ' + unit + 's');
  }
  function coRenew(cart) {
    var chain = Promise.resolve();
    (cart && cart.items || []).forEach(function (it) {
      if (!it.selling_plan_allocation || (it.properties && it.properties[CY_RENEW])) return;
      var props = {}, k;
      for (k in (it.properties || {})) props[k] = it.properties[k];
      props[CY_RENEW] = coRenewText(it.selling_plan_allocation);
      chain = chain.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: J,
          body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props }) });
      });
    });
    return chain;
  }
  /* Yves 24 Oct (v2, Gifts unlocked box): the free e-book follows the tier, never Subscribe vs one-time. Read the cart:
     2+ units of non-gift lines (Buy 2 Get 1 = 3 units, Buy 3 Get 2 = 5) = gift qty 1; Buy One = gift qty 0 (removes
     one left over from an earlier pass). Replaces the subscription-only rule from earlier the same day. */
  function coGiftWant(cart) {
    var units = 0, have = 0;
    (cart && cart.items || []).forEach(function (it) {
      if (+it.variant_id === CY_GIFT || +it.id === CY_GIFT) have += it.quantity || 0;
      else units += it.quantity || 0;
    });
    return { want: units >= 2 ? 1 : 0, have: have };
  }
  function coGift() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var g = coGiftWant(cart);
        if (g.want === g.have) return cart;
        var u = {}; u[CY_GIFT] = g.want;
        return fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: u }) })
          .then(function (r) { return r.json(); });
      })
      .then(coRenew)
      .catch(function () {});
  }
  function coGo() {
    if (!co.armed || co.gone) return;
    co.gone = true;
    var go = CYPDP.checkout.go || function (u) { window.location.assign(u); };
    var done = false, fin = function () { if (!done) { done = true; go(co.url); } };
    coGift().then(fin, fin);
    setTimeout(fin, 4000);
  }
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    var pf = f && f.closest && f.closest('product-form[data-cy-skip-cart]');
    if (!pf || coDesign()) return;
    co.url = pf.getAttribute('data-cy-skip-cart') || '/checkout';
    co.armed = Date.now(); co.gone = false;
    root0.classList.add('cy-to-checkout');
    clearTimeout(co.t);
    co.t = setTimeout(coDisarm, 20000);
  }, true);
  window.addEventListener('pageshow', function () { co.gone = false; coDisarm(); });
  /* Dawn's pubsub.js / constants.js are deferred: subscribe once they ran (DOMContentLoaded at the latest) */
  /* Dawn declares PUB_SUB_EVENTS with const: a global binding, not a window property */
  function coEvents() {
    try { return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null; } catch (err) { return null; } /* eslint-disable-line no-undef */
  }
  function coSubscribe() {
    var EV = coEvents();
    if (co.sub || typeof window.subscribe !== 'function' || !EV) return;
    co.sub = true;
    try {
      window.subscribe(EV.cartUpdate, function (ev) {
        if (ev && ev.source === 'product-form' && !(ev.cartData && ev.cartData.status)) coGo();
      });
      window.subscribe(EV.cartError, function () { coDisarm(); });
    } catch (err) { /* pubsub missing: the fetch path still works */ }
  }
  coSubscribe();
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', coSubscribe);
  window.addEventListener('load', coSubscribe);
  if (typeof window.fetch === 'function' && !window.fetch._cyCo) {
    var coFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var p = coFetch.apply(window, arguments);
      if (!co.armed || !/\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0])) return p;
      p.then(function (res) {
        if (!res || !res.ok) { coDisarm(); return; }
        res.clone().json().then(function (j) {
          if (j && j.status) coDisarm(); else setTimeout(coGo, 0);
        }, function () { setTimeout(coGo, 0); });
      }, function () { coDisarm(); });
      return p;
    };
    wrapped._cyCo = true;
    window.fetch = wrapped;
  }

  /* ================= nav (clone header strip, D18) ================= */
  function navSet(btn, open) {
    var id = btn.getAttribute('aria-controls');
    var dr = id ? doc.getElementById(id) : null;
    if (!dr) { var host = btn.closest('[data-cy-nav]'); dr = host && host.querySelector('[data-cy-nav-drawer]'); }
    if (!dr) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    setHidden(dr, !open);
    btn.classList.toggle('is-open', open);
  }
  function modNav(root) {
    all(root, '[data-cy-nav-toggle]').forEach(function (btn) {
      if (!claim(btn, 'nav')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        navSet(btn, btn.getAttribute('aria-expanded') !== 'true');
      });
    });
  }
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    all(doc, '[data-cy-nav-toggle][aria-expanded="true"]').forEach(function (b) { navSet(b, false); b.focus(); });
  });
  doc.addEventListener('click', function (e) {
    all(doc, '[data-cy-nav-toggle][aria-expanded="true"]').forEach(function (b) {
      var host = b.closest('[data-cy-nav]');
      if (host && !host.contains(e.target)) navSet(b, false);
    });
  });

  /* ================= gifts unlocked (Yves 24 Oct) ================= */
  /* snippets/cy-pdp-gifts: a tile is on when the selected tier >= its data-at. src "kaching" = index + 1 of the
     selected Kaching bar; src "cards" = data-tier of the pricing cards section around the box. The hero box under
     Kaching takes its tiles from the pricing section's box (data-cy-gifts-cfg), so that section's settings are the one
     place to edit the gifts. Unlocks follow the tier only, never Subscribe vs one-time. */
  function giftsKachingTier() {
    var kb = kachingRoot();
    if (!kb) return 0;
    var bars = all(kb, '.kaching-bundles__bar');
    for (var i = 0; i < bars.length; i++) {
      var r = bars[i].querySelector('input[type="radio"]');
      if (bars[i].classList.contains('kaching-bundles__bar--selected') || (r && r.checked)) return i + 1;
    }
    return 0;
  }
  function giftsPaint(box) {
    var t = 0;
    if (box.getAttribute('data-cy-gifts') === 'cards') {
      var pc = box.closest('.cyx-pc');
      t = pc ? num(pc.getAttribute('data-tier'), 0) : 0;
    } else t = giftsKachingTier();
    if (!t) return;
    if (box.getAttribute('data-tier') !== String(t)) box.setAttribute('data-tier', String(t));
    all(box, '.cy-gifts__t').forEach(function (el) {
      var on = t >= num(el.getAttribute('data-at'), 1);
      if (el.classList.contains('is-on') !== on) el.classList.toggle('is-on', on);
    });
  }
  var giftsQ = 0;
  function giftsAll() {
    if (giftsQ) return;
    giftsQ = setTimeout(function () { giftsQ = 0; all(doc, '[data-cy-gifts="kaching"]').forEach(giftsPaint); }, 30);
  }
  var giftsWired = false;
  function giftsWire() {
    if (giftsWired) return;
    giftsWired = true;
    doc.addEventListener('cy:offer', giftsAll);
    doc.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.kaching-bundles')) giftsAll(); }, true);
    doc.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.kaching-bundles__bar')) { giftsAll(); setTimeout(giftsAll, 200); } }, true);
    var tries = 0, seen = null;
    (function watch() {
      var kb = kachingRoot();
      if (kb && kb !== seen) {
        seen = kb;
        giftsAll();
        if (window.MutationObserver) new MutationObserver(giftsAll).observe(kb, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
      }
      if (++tries < 120) setTimeout(watch, kb ? 1000 : 150); /* re-attach if Kaching re-renders its root */
    })();
  }
  function modGifts(root) {
    var src = doc.querySelector('[data-cy-gifts-cfg]');
    all(root, '[data-cy-gifts]').forEach(function (box) {
      if (!claim(box, 'gifts')) return;
      if (box.getAttribute('data-cy-gifts') === 'cards') {
        var pc = box.closest('.cyx-pc');
        if (pc && window.MutationObserver) {
          new MutationObserver(function () { giftsPaint(box); }).observe(pc, { attributes: true, attributeFilter: ['data-tier'] });
        }
      } else if (src && src !== box) {
        var row = src.querySelector('.cy-gifts__row'), mine = box.querySelector('.cy-gifts__row');
        var h = src.querySelector('.cy-gifts__h'), mh = box.querySelector('.cy-gifts__h');
        if (row && mine) mine.parentNode.replaceChild(row.cloneNode(true), mine);
        if (h && mh) mh.textContent = h.textContent;
        if (src.getAttribute('aria-label')) box.setAttribute('aria-label', src.getAttribute('aria-label'));
      }
      giftsPaint(box);
    });
    if (all(doc, '[data-cy-gifts="kaching"]').length) giftsWire();
  }

  /* ================= buy box v3 (Yves 24 Oct, Primal sample) ================= */
  /* Hero Kaching bars: tighter, the selected bar opens a panel (You save, item line with its value, Plus free gifts
     lines), Kaching's own one-time link is hidden and re-drawn under the hero gifts box as "One Time Purchase $x $y ->"
     (a click still runs Kaching's link, so the cart path is Kaching's). Copy + gift lines + one-time prices come from
     the pricing cards section (script[data-cy-bb-cfg]); the bar numbers come from the Kaching DOM. Offer images:
     script[data-cy-offer-imgs] (cy-pdp-main offer_img_1..3) swaps the first gallery image when the tier changes. */
  var bb = { cfg: null, css: false, q: 0, tier0: 0, swapped: false, orig: null, imgs: null, wired: false };
  var BB_CHK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var BB_ARR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function bbCss() {
    if (bb.css) return;
    bb.css = true;
    var k = '.kaching-bundles';
    var css = [
      k + ' .kaching-bundles__bar-wrapper{padding:12px 12px 8px!important}',
      k + ' .kaching-bundles__bar-main{gap:12px!important}',
      /* 24 Oct r3 (Yves, Primal match): tight top (title ~12px under the border), thumb left, title + You save stacked,
         price + struck compare stacked right, badge lifted onto the border so it clears the price */
      k + ' .kaching-bundles__bar-container .kaching-bundles__bar-main{margin:0!important;align-items:flex-start!important;min-height:0!important}',
      k + ' .kaching-bundles__bar-content{align-items:flex-start!important}',
      k + ' .kaching-bundles__bar-pricing{align-items:flex-end!important}',
      k + ' img.kaching-bundles__bar-image{width:62px!important;min-width:62px!important;max-width:62px!important;height:56px!important;object-fit:contain!important;object-position:center!important}',
      k + ' .kaching-bundles__bar--selected:not(.cybb-one) .kaching-bundles__bar-first-line{flex-direction:column!important;align-items:flex-start!important;gap:0!important}',
      k + ' .kaching-bundles__bar-most-popular{transform:translateY(-8px)}',
      k + ' .kaching-bundles__bar:has(.kaching-bundles__bar-most-popular){margin-top:14px!important}',
      k + ' .kaching-bundles__bar--selected:not(.cybb-one) .kaching-bundles__bar-subtitle,' + k + ' .kaching-bundles__bar--selected:not(.cybb-one) .kaching-bundles__bar-label{display:none!important}',
      '.cybb-sv{display:none;margin-top:2px;font-size:15px;font-weight:400;line-height:1.3;color:#6B5646}',
      k + ' .kaching-bundles__bar--selected .cybb-sv{display:block}',
      '.cybb-xp{display:none;margin:8px 0 2px;padding-top:8px;border-top:1px solid #E3D3C3;text-align:left;font-family:var(--cy-fb)}',
      k + ' .kaching-bundles__bar--selected .cybb-xp{display:block}',
      '.cybb-xi{display:flex;gap:10px;align-items:flex-start;padding:4px 0}',
      '.cybb-xi>i{flex:0 0 20px;width:20px;height:20px;margin-top:1px;border-radius:50%;background:var(--bar-selected-border-color,#2B1D14);color:#FFFFFF;display:flex;align-items:center;justify-content:center}',
      '.cybb-xi>i.is-g{background:none;color:var(--bar-selected-border-color,#2B1D14)}',
      '.cybb-xi svg{width:12px;height:12px}.cybb-xi>i.is-g svg{width:17px;height:17px}',
      '.cybb-xi strong{display:block;font-size:14.5px;font-weight:700;line-height:1.3;color:#2B1D14}',
      '.cybb-xi small{display:block;margin-top:1px;font-size:13px;font-weight:400;line-height:1.35;color:#6B5646}',
      '.cybb-xd{display:flex;align-items:center;gap:12px;margin:4px 0 2px;font-size:12.5px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:var(--bar-selected-border-color,#2B1D14)}',
      '.cybb-xd:before,.cybb-xd:after{content:"";flex:1;height:1px;background:#E3D3C3}',
      'html.cybb-otp-on ' + k + ' .kaching-bundles__subscriptions-wrapper{display:none!important}',
      '.cybb-otp{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin:14px auto 4px;padding:4px 6px;background:none;border:0;font-family:var(--cy-fb);font-size:15px;font-weight:500;line-height:1.4;color:#2B1D14;cursor:pointer}',
      '.cybb-otp .cybb-otu{display:inline-flex;gap:8px;text-decoration:underline;text-underline-offset:4px;text-decoration-thickness:1px}',
      '.cybb-otp s{color:#6B5646}.cybb-otp svg{width:18px;height:18px;flex:0 0 18px}',
      '.cybb-otp[aria-busy]{opacity:.5;pointer-events:none}'
    ].join('\n');
    var st = doc.createElement('style');
    st.setAttribute('data-cy-bb-css', '');
    st.textContent = css;
    doc.head.appendChild(st);
  }
  function bbReadCfg() {
    if (bb.cfg) return bb.cfg;
    var el = doc.querySelector('script[data-cy-bb-cfg]');
    if (!el) return null;
    try { bb.cfg = JSON.parse(el.textContent || '{}'); } catch (e) { bb.cfg = null; }
    return bb.cfg;
  }
  function bbEsc(s) { var d = doc.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }
  function bbItem(line, sub, gift) {
    return '<span class="cybb-xi"><i' + (gift ? ' class="is-g"' : '') + '>' + BB_CHK + '</i><span><strong>' + bbEsc(line) +
      '</strong>' + (sub ? '<small>' + bbEsc(sub) + '</small>' : '') + '</span></span>';
  }
  /* 24 Oct r3 (Yves): hero bar thumbnails from the pricing tier blocks (bb_thumb): Buy 2 = 2 pouches + e-book,
     Buy 3 = 3 pouches + e-book + gift box. Kaching's own bar image stays when the block has none (Buy One). */
  function bbThumb(bar, tier, cfg) {
    var t = cfg.tiers && cfg.tiers[tier - 1];
    var img = bar.querySelector('img.kaching-bundles__bar-image');
    if (!t || !t.thumb || !img) return;
    var src = t.thumb.indexOf('//') === 0 ? 'https:' + t.thumb : t.thumb;
    if (img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.setAttribute('src', src); }
  }
  var BB_ITEM_FROM = 3; /* 24 Oct r3 (Yves, Primal): Buy 2 panel = the e-book line only; pouch line + gifts divider from Buy 3 */
  function bbPaintBar(bar, tier, cfg) {
    var n = cyBarQty(bar);
    bbThumb(bar, tier, cfg);
    /* 24 Oct r2 (Yves): Buy One opens no panel (no You save, no item lines, no gifts) */
    if (tier === 1) {
      bar.classList.add('cybb-one');
      var o1 = bar.querySelector('.cybb-xp'), s1 = bar.querySelector('.cybb-sv');
      if (o1) o1.remove();
      if (s1) s1.remove();
      return;
    }
    var pEl = bar.querySelector('.kaching-bundles__bar-price');
    var fEl = bar.querySelector('.kaching-bundles__bar-full-price');
    var price = pEl ? parseMoney(pEl.textContent) : 0;
    var full = fEl ? parseMoney(fEl.textContent) : 0;
    var unit = offer.seed && offer.seed.unit;
    if (unit > 0 && n > 0) full = Math.round(unit * n * 100) / 100;
    var title = bar.querySelector('.kaching-bundles__bar-title');
    var wrap = bar.querySelector('.kaching-bundles__bar-wrapper') || bar;
    if (!title || !(n > 0)) return;
    /* You save */
    var sv = bar.querySelector('.cybb-sv');
    var save = full > price && price > 0 ? Math.round((full - price) * 100) / 100 : 0;
    var svTxt = save && cfg.save ? cfg.save.replace('{amount}', formatMoney(save)) : '';
    if (svTxt) {
      if (!sv || sv.parentNode !== title.parentNode) { if (sv) sv.remove(); sv = doc.createElement('span'); sv.className = 'cybb-sv'; title.parentNode.insertBefore(sv, title.nextSibling); }
      if (sv.textContent !== svTxt) sv.textContent = svTxt;
    } else if (sv) sv.remove();
    /* panel */
    var name = n === 1 ? (cfg.item1 || cfg.item) : cfg.item;
    var withItem = tier >= BB_ITEM_FROM;
    var html = withItem ? bbItem(n + 'x ' + name + (full ? ' (' + formatMoney(full) + ' Value)' : ''),
      String(cfg.itemSub || '').replace('{days}', String(n * 30)).replace('{qty}', String(n)), false) : '';
    var gl = (cfg.gifts_on && cfg.gifts) ? cfg.gifts.filter(function (g) { return g && tier >= g.at; }) : [];
    if (gl.length) {
      if (cfg.plus && withItem) html += '<span class="cybb-xd">' + bbEsc(cfg.plus) + '</span>';
      gl.forEach(function (g) { html += bbItem(g.line, g.sub, true); });
    }
    var xp = bar.querySelector('.cybb-xp');
    if (!xp || xp.parentNode !== wrap) { if (xp) xp.remove(); xp = doc.createElement('div'); xp.className = 'cybb-xp'; xp.setAttribute('aria-hidden', 'true'); wrap.appendChild(xp); }
    if (xp.getAttribute('data-h') !== html) { xp.innerHTML = html; xp.setAttribute('data-h', html); }
  }
  function bbOtp(tier, cfg) {
    var link = doc.querySelector('.kaching-bundles .kaching-bundles__subscriptions__link');
    var box = doc.querySelector('[data-cy-gifts="kaching"]');
    var el = doc.querySelector('.cybb-otp');
    var t = cfg.tiers && cfg.tiers[tier - 1];
    if (!link || !cfg.otp || !t) { if (el) el.hidden = true; doc.documentElement.classList.remove('cybb-otp-on'); return; }
    var anchor = box || link.closest('.kaching-bundles');
    if (!el) {
      el = doc.createElement('button');
      el.type = 'button';
      el.className = 'cybb-otp';
      el.addEventListener('click', function () {
        var l = doc.querySelector('.kaching-bundles .kaching-bundles__subscriptions__link');
        if (!l) return;
        el.setAttribute('aria-busy', 'true');
        setTimeout(function () { el.removeAttribute('aria-busy'); }, 4000);
        l.click();
      });
    }
    if (el.previousElementSibling !== anchor) anchor.parentNode.insertBefore(el, anchor.nextSibling);
    var html = '<span class="cybb-otu"><span>' + bbEsc(cfg.otp) + '</span><b>' + bbEsc(t.oneTxt) + '</b>' +
      (t.cmp > t.one ? '<s>' + bbEsc(t.cmpTxt) + '</s>' : '') + '</span>' + BB_ARR;
    if (el.getAttribute('data-h') !== html) { el.innerHTML = html; el.setAttribute('data-h', html); }
    el.hidden = false;
    doc.documentElement.classList.add('cybb-otp-on');
  }
  /* offer hero images */
  function bbGallery() {
    var mg = doc.querySelector('media-gallery');
    if (!mg) return null;
    var li = mg.querySelector('li.product__media-item');
    var img = li && li.querySelector('img');
    if (!img) return null;
    var th = mg.querySelector('[id^="Slider-Thumbnails"] li img, .thumbnail-list li img');
    return { mg: mg, li: li, img: img, th: th };
  }
  function bbSwap(tier, quiet) {
    if (!bb.imgs) return;
    var g = bbGallery();
    if (!g) return;
    if (!bb.orig) bb.orig = { src: g.img.getAttribute('src'), srcset: g.img.getAttribute('srcset'), alt: g.img.getAttribute('alt'),
      th: g.th ? { src: g.th.getAttribute('src'), srcset: g.th.getAttribute('srcset') } : null };
    var o = bb.imgs[tier - 1];
    function set(el, a, v) { if (v == null) el.removeAttribute(a); else if (el.getAttribute(a) !== v) el.setAttribute(a, v); }
    if (o) {
      set(g.img, 'srcset', o.srcset); set(g.img, 'src', o.src); if (o.alt) set(g.img, 'alt', o.alt);
      if (g.th) { set(g.th, 'srcset', null); set(g.th, 'src', o.thumb || o.src); }
    } else {
      set(g.img, 'srcset', bb.orig.srcset); set(g.img, 'src', bb.orig.src); set(g.img, 'alt', bb.orig.alt);
      if (g.th && bb.orig.th) { set(g.th, 'srcset', bb.orig.th.srcset); set(g.th, 'src', bb.orig.th.src); }
    }
    g.img.removeAttribute('loading');
    if (quiet) return;                           /* init: first slide is already active, no scroll/jump */
    var id = g.li.getAttribute('data-media-id');
    try { if (id && typeof g.mg.setActiveMedia === 'function') g.mg.setActiveMedia(id, false); } catch (e) {}
    var sl = g.li.parentElement;
    if (sl && sl.scrollLeft) { try { sl.scrollTo({ left: 0, behavior: 'smooth' }); } catch (e) { sl.scrollLeft = 0; } }
  }
  function bbRun() {
    bb.q = 0;
    var cfg = bbReadCfg();
    var kb = kachingRoot();
    var tier = giftsKachingTier();
    if (cfg && kb) {
      all(kb, '.kaching-bundles__bar').forEach(function (bar, i) { bbPaintBar(bar, i + 1, cfg); });
      if (tier) bbOtp(tier, cfg);
    }
    if (tier && bb.imgs) {
      if (!bb.tier0) { bb.tier0 = tier; if (tier !== bb.last) bbSwap(tier, true); } /* first paint: default tier's offer image */
      else if (tier !== bb.last) bbSwap(tier);
      bb.last = tier;
    }
  }
  function bbSchedule() { if (!bb.q) bb.q = setTimeout(bbRun, 40); }
  function modBbox() {
    var cfgEl = doc.querySelector('script[data-cy-bb-cfg]');
    var imgEl = doc.querySelector('script[data-cy-offer-imgs]');
    if (!cfgEl && !imgEl) return;
    if (imgEl && !bb.imgs) {
      try { bb.imgs = JSON.parse(imgEl.textContent || '[]'); } catch (e) { bb.imgs = null; }
      var sd = doc.querySelector('script[data-cy-offer-seed]'), t0 = 0;
      try { t0 = parseInt(JSON.parse((sd && sd.textContent) || '{}').tier, 10) || 0; } catch (e) {}
      if (bb.imgs && t0) { bbSwap(t0, true); bb.last = t0; }
    }
    if (cfgEl) bbCss();
    if (bb.wired) { bbSchedule(); return; }
    bb.wired = true;
    doc.addEventListener('cy:offer', bbSchedule);
    doc.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.kaching-bundles__bar')) { bbSchedule(); setTimeout(bbSchedule, 250); } }, true);
    var tries = 0, seen = null;
    (function watch() {
      var kb = kachingRoot();
      if (kb && kb !== seen) {
        seen = kb;
        bbSchedule();
        if (window.MutationObserver) new MutationObserver(function (ms) {
          for (var i = 0; i < ms.length; i++) {
            var t = ms[i].target;
            if (t && t.closest && (t.closest('.cybb-xp') || t.closest('.cybb-sv'))) continue;
            bbSchedule(); return;
          }
        }).observe(kb, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      }
      if (++tries < 120) setTimeout(watch, kb ? 1000 : 150);
    })();
  }

  /* ================= init ================= */
  var MODULES = [
    ['count', modCount], ['stock', modStock], ['marquee', modMarquee], ['timer', modTimer], ['offer', modOffer],
    ['video', modVideo], ['carousel', modCarousel], ['acc', modAcc], ['flip', modFlip], ['reveal', modReveal],
    ['journey', modJourney], ['sticky', modSticky], ['shine', modShine], ['nav', modNav], ['gallery', modGallery],
    ['gifts', modGifts], ['bbox', modBbox]
  ];
  function init(root) {
    root = root || doc;
    MODULES.forEach(function (m) {
      try { m[1](root); } catch (e) { if (window.console) console.warn('[CYPDP] ' + m[0], e); }
    });
    if (!timers.length) { timerState.active = false; applyMirrors(); }
  }

  var CYPDP = window.CYPDP = {
    version: '2.2.0',
    init: init,
    finalize: finalize,
    reduced: reduced,
    formatMoney: function (amount, fmt) { return formatMoney(amount, fmt); },
    timerState: timerState,
    offerState: null,
    count: { run: countRun, final: countFinal },
    checkout: { state: co, go: null, gift: coGift, giftWant: coGiftWant },
    modules: {}
  };
  MODULES.forEach(function (m) { CYPDP.modules[m[0]] = m[1]; });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:block:select', function (e) { finalize(e.target); });
})();
